<ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
  <ion-toolbar mode="md">
    <ion-title class="ion-text-center header-title">{{ 'MY_PROFILE.TITLE' | translate }}</ion-title>

    <ion-buttons slot="start" class="header-buttons">
      <ion-back-button color="secondary" defaultHref="/"></ion-back-button>
    </ion-buttons>

     <app-top-right slot="end"></app-top-right>

  </ion-toolbar>
  </ion-grid>
</ion-header>

<!-- page content start -->
<ion-content class="bookings" *ngIf="me$ | async as me">
  <ion-grid fixed class="ion-no-padding">
    <div class="user-info">
      <!--<div class="user-info__picture" *ngIf="me.facebookId">
        <img [src]="'https://graph.facebook.com/' + me.facebookId + '/picture?width=500&height=500'">
      </div>
      <div class="user-info__picture" *ngIf="!me.facebookId">
        <img src="https://assets.pricepilot.io/img/employees/blank.jpg">
      </div>-->
      <h3 class="user-info__name">{{ me.firstName }} {{ me.lastName }}</h3>
      <h5 class="user-info__phone" *ngIf="me.phone">{{ me.phone || '' | nationalFormat : 'SI' }}</h5>
      <p class="user-info__email">{{ me.email }}</p>
    </div>

    <ion-list class="user-info__items">
      <ion-item class="ion-no-padding" [routerLink]="['/moj-profil', 'moje-rezervacije']">
        <span>{{ 'MY_PROFILE.MY_BOOKINGS' | translate }}</span>
        <!--div class="my-profile-notif">1</div-->
        <ion-icon class="arrow-right"></ion-icon>
      </ion-item>
      <ion-item class="ion-no-padding" [routerLink]="['/moj-profil', 'osebni-podatki']">
        <span>{{ 'MY_PROFILE.PERSONAL_DATA' | translate }}</span>
        <ion-icon class="arrow-right"></ion-icon>
      </ion-item>
      <ion-item class="ion-no-padding" [routerLink]="['/moj-profil', 'privolitve']">
        <span>{{ 'MY_PROFILE.NOTIFICATIONS' | translate }}</span>
        <ion-icon class="arrow-right"></ion-icon>
      </ion-item>
      <!--ion-item no-padding>
        <span>Moje ocene</span>
        <ion-icon class="arrow-right"></ion-icon>
      </ion-item-->
    </ion-list>
  </ion-grid>
</ion-content>
<!-- page content end -->

<ion-footer padding mode="md">
  <ion-toolbar no-padding>
    <ion-button (click)="logout()"  mode="md" color="secondary" expand="full" class="btn--large ion-no-margin" expand="full">{{ 'MY_PROFILE.LOGOUT' | translate }}</ion-button>
  </ion-toolbar>
</ion-footer>